import React, { useState, useEffect, useRef } from "react";
import './CourseRequestForm.css'
import Multiselect from 'multiselect-react-dropdown';
import { useForm, Controller } from 'react-hook-form';
import validationRules from '../../util/validationRules/ValidationRules';

import { post, get } from '../../util/axiosConfig/AxiosConfig'
import Loader from '.././../util/preloader/Preloader';
import showAlert from "../alert/Alert";
import axios from "axios";
import { ENV } from '../../util/Env';
import { useNavigate } from 'react-router-dom';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Header from "../layout/Header";
import Footer from "../layout/Footer";



const CourseRequestForm = () => {

    const { control, handleSubmit, register, setValue, formState: { errors }, reset, setError, trigger, clearErrors } = useForm();
    const datePickerRef = useRef(null);
    const navigate = useNavigate();

    // Calculate the minimum date (current date + 2 days)
    const minSelectableDate = new Date();
    minSelectableDate.setDate(minSelectableDate.getDate() + 3);

    const [placeholder, setPlaceholder] = useState("Select courses");
    const [loading, setLoading] = useState(false);

    const [agreement, setAgreement] = useState(true);
    const [allIndustry, setAllIndustry] = useState([]);
    const [allUserRange, setAllUserRange] = useState([]);
    const [coursesList, setCoursesList] = useState([]);
    const [defaultSelectedCourses, setDefaultSelectedCourses] = useState([]);

    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("+91");
    const [selectedFlag, setSelectedFlag] = useState('');
    const [selectedIDD, setSelectedIDD] = useState('');

    const [allDates, setAllDates] = useState([
        {id : 1, label : "Immediately", value: "Immediately"},
        {id : 2, label : "In next 30 days", value: "In next 30 days"},
        {id : 3, label : "1-3 months", value: "1-3 months"},
        {id : 4, label : "3-6 months", value: "3-6 months"},
        {id : 5, label : "6-12 months", value: "6-12 months"},
        {id : 6, label : "Not sure", value: "Not sure"}
    ]);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchMasterdata('admin/api/v1/lms-admin/course/enquiry/industryMaster/getAllIndustry', setAllIndustry);
        fetchMasterdata('admin/api/v1/lms-admin/course/enquiry/userCountRangeMaster/getAllUserCountRange', setAllUserRange);
    }, [])

    useEffect(() => {
        fetchCountryCodeAndFlag();
        fetchCourseList();
    }, []);

  

    useEffect(() => {
        const country = countries.find((country) => {
            const iddCode = country.idd && country.idd.suffixes && country.idd.suffixes[0]
                ? `${country.idd.root}${country.idd.suffixes[0]}`
                : null;
            return iddCode === selectedCountry;
        });
        if (country) {
            setSelectedFlag(country.flags ? country.flags[0] : "");
            setSelectedIDD(
                country.idd && country.idd.suffixes && country.idd.suffixes[0]
                    ? `${country.idd.root}${country.idd.suffixes[0]}`
                    : "N/A"
            );
        }
    }, [selectedCountry, countries]);

    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Fetch course list
    const fetchCourseList = async () => {
        const courseCategory = getQueryParam('cataGory');

        if(courseCategory){
            console.log('With course category')
            try {
                // setLoading(true);
                //web/api/v1/lms-web/open/get-course-list-by-category-id/${courseCategory}
                const response = await get(`web/api/v1/lms-web/open/get-course-list`);
                setCoursesList(response);
    
                const userSelectedCourseId = getQueryParam('courseId');
                const courseIdStr = String(userSelectedCourseId).trim();
                const defaultCourse = response.find(course => String(course.id) === courseIdStr);
                if (defaultCourse) {
                    setDefaultSelectedCourses([defaultCourse]);
                    setValue('courseList', [defaultCourse]);
                }
            } catch (error) {
                setLoading(false);
                console.error(error);
            } finally {
                setLoading(false);
            }
        }else{
            console.log('No course category')
            try {
                // setLoading(true);
                const response = await get(`web/api/v1/lms-web/open/get-course-list`);
                setCoursesList(response);
    
                const userSelectedCourseId = getQueryParam('courseId');
                const courseIdStr = String(userSelectedCourseId).trim();
                const defaultCourse = response.find(course => String(course.id) === courseIdStr);
                if (defaultCourse) {
                    setDefaultSelectedCourses([defaultCourse]);
                    setValue('courseList', [defaultCourse]);
                }
            } catch (error) {
                setLoading(false);
                console.error(error);
            } finally {
                setLoading(false);
            }
        }
    };


    // Fetch country code and Flag
    const fetchCountryCodeAndFlag = async () => {
        try {
            // setLoading(true);
            const response = await get("https://restcountries.com/v3/all");
            setCountries(response);

            // Find India from the response and set it as the default
            const india = response.find((country) => {
                const iddCode = country.idd && country.idd.suffixes && country.idd.suffixes[0]
                    ? `${country.idd.root}${country.idd.suffixes[0]}`
                    : null;
                return iddCode === "+91";
            });

            if (india) {
                setSelectedCountry("+91");
                setSelectedFlag(india.flags ? india.flags[0] : "");
                setValue('location', "+91");
                setSelectedIDD(
                    india.idd && india.idd.suffixes && india.idd.suffixes[0]
                        ? `${india.idd.root}${india.idd.suffixes[0]}`
                        : "N/A"
                );
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // const courseOptions = [
    //     { id: '1', course: 'course 1' },
    //     { id: '2', course: 'course 2' },
    //     { id: '3', course: 'course 3' },
    //     { id: '4', course: 'course 4' },
    //     { id: '5', course: 'course 5' },
    //     { id: '6', course: 'course 6' },
    //     { id: '7', course: 'course 7' },
    //     { id: '8', course: 'course 8' }
    // ]

    const fetchMasterdata = async (api, stateToStore) => {
        try {
            // setLoading(true);
            const response = await get(api);
            stateToStore(response);
        } catch (error) {
            setLoading(false);
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    function validateEmail(email) {
        const emailPattern = /^(?!.*\.\.)(?!.*\.$)(?!.*@.*\.\.)(?!.*\.\@)[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }

    // const onSubmit = async (data) => {

    //         if (validateEmail(data.email)) {
    //         setError("email", {
    //             type: "manual",
    //             message: "Input a valid email"
    //         });
    //     } else {
    //         alert('valid')
    //     }
    // };


    const onSubmit = data => {

      const formData = {
        
            "courseTitle": data.courseTitle,
            "desc": data.description,
            "name": data.yourName,
            "email": data.email,
            "optForNewsLetter": true
      }

            const sendData = async () => {
                try {
                    setLoading(true);
                    const response = await post('admin/api/v1/lms-admin/course/request/create', formData);
                    setLoading(false);
                    if (response.message == 'Created') {
                        showAlert('Great!', ' Course request details have been submitted. Our team will get back to you soon!', 'success', 'OK', false, false, activityCallback, false, 'Cancel', '');
                    } else {
                        showAlert('Abort!', `Unable to submit course request data`, 'error', 'Ok', false, false, '', false, '', '');
                    }

                } catch (error) {
                    showAlert('Abort!', ' Unable to submit course request data', 'error', 'Ok', false, false, '', false, '', '');
                    setLoading(false);
                    setError(error.response.data)
                } finally {
                    setLoading(false);
                }
            };
            sendData();
        }
    

    const activityCallback = () => {
        navigate('/Home')
    }

    const handleSelect = (selectedList) => {
        if (selectedList.length >= 3) {
            setPlaceholder("");
        } else {
            setPlaceholder("Select more courses");
        }
    };

    const handleRemove = (selectedList) => {
        if (selectedList.length < 3) {
            setPlaceholder("Select more courses");
        }
    };

    const handleAgreementChange = (event) => {
        setAgreement(event.target.checked)
    }

    const handleCountryCodeChange = (event) => {
        const countryCode = event.target.value;
        setValue('phone', '');
        clearErrors('phone');
        setSelectedCountry(countryCode)
        setValue('location', countryCode)
        clearErrors('location');
    }


    const phoneValidationRules = selectedCountry === '+91' ? {
        required: "Phone number is required",
        pattern: {
            value: /^[1-9]\d{9}$/,
            message: "Invalid phone number",
        },
        maxLength: {
            value: 10,
            message: "Phone number cannot exceed 10 digits",
        }
    } : {
        required: "Phone number is required",
        pattern: {
            value: /^[1-9]\d{6,9}$/,
            message: "Invalid phone number",
        },
        minLength: {
            value: 7,
            message: "Phone number must be at least 7 digits",
        },
        maxLength: {
            value: 10,
            message: "Phone number cannot exceed 10 digits",
        }
    };


    return (
        <React.Fragment>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Header />
                    <div className="courseRequestForm_main">
                        <div className="container course_request_container">
                            <div className="courseRequest_form_title_main">
                                <h1 className="form_title">Course Request Form 
                                    {/* <span className="title_icon"><i className="fa-solid fa-book"></i></span> */}
                                </h1>
                                <p className="courseRequest_form_descripton">Is there a specific course you need that’s not currently available? Let us know, and we’ll work on adding it to our platform.</p>
                            </div>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idCourseTitle" class="form-label">Course Title<span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control cstm_fromControl"
                                                id="idCourseTitle"
                                                maxLength={50}
                                                aria-describedby="idCourseTitle"
                                                placeholder="Enter course title"
                                                name="courseTitle"
                                                {...register('courseTitle', {
                                                    required: "Course title is required",
                                                    // pattern: {
                                                    //     value: validationRules.firstName.pattern,
                                                    //     message: validationRules.firstName.message,
                                                    // },
                                                })}
                                            />
                                            {errors.courseTitle && (
                                                <p className="error-message text-danger">{errors.courseTitle.message}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idComment" class="form-label">Description/Topics Covered </label>
                                            <textarea
                                                className="form-control cstm_fromControl"
                                                id="exampleFormControlTextarea1"
                                                rows="5"
                                                maxLength={500}
                                                placeholder="Enter your requirement"
                                                {...register('description')}
                                                
                                            ></textarea>
                                            {/* {errors.description && (
                                                <p className="error-message text-danger">{errors.description.message}</p>
                                            )} */}
                                        </div>
                                    </div>

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idYourName" class="form-label">Your Name<span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control cstm_fromControl"
                                                id="idYourName"
                                                aria-describedby="idYourName"
                                                placeholder="Enter your name"
                                                name="yourName"
                                                {...register('yourName', {
                                                    required: "Name is required",
                                                    pattern: {
                                                        value: validationRules.lastName.pattern,
                                                        message: validationRules.lastName.message,
                                                    },
                                                })}
                                            />
                                            {errors.yourName && (
                                                <p className="error-message text-danger">{errors.yourName.message}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idEmail" class="form-label">Email<span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control cstm_fromControl"
                                                id="idEmail"
                                                aria-describedby="idEmail"
                                                placeholder="Enter email"
                                                name="email"
                                                {...register('email', {
                                                    required: "Email is required",
                                                    pattern: {
                                                        value: /^(?!.*\.\.)(?!.*\.$)(?!.*\.\@)[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/,
                                                        message: 'Invalid email',
                                                    },
                                                })}
                                            />
                                            {errors.email && (
                                                <p className="error-message text-danger">{errors.email.message}</p>
                                            )}
                                        </div>
                                    </div>
                                    
                                </div>

                                <div className="inquery_check_main">
                                    <div className="form-check inquery_cstm_form_check_main">
                                        <input className="form-check-input cstm_check_inquery"
                                            type="checkbox"
                                            checked={agreement}
                                            id="agreement"
                                            onChange={handleAgreementChange}
                                        />
                                        <label className="form-check-label" for="agreementt">
                                            By providing your contact info, you agree to receive communications from Finlabs. You can <a href="#"><span className="focus_text">opt-out</span></a> at any time. For details, refer to our <a href="#"><span className="focus_text">Privacy Policy.</span></a>
                                        </label>
                                    </div>
                                </div>

                                <div className="courseRequest_form_submit_btn_area">
                                    <button className="courseRequest_form_submit">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <Footer />
                </>
            )

            }
        </React.Fragment>
    );
}

export default CourseRequestForm;